/* tslint:disable */
/* eslint-disable */
/**
 * Coproperty API
 * MRI coproperties (the risk entity of the MRI branch) — creation, structural attributes, buildings, and attachment to the risk.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCopropertyComplementsCommand
 */
export interface UpdateCopropertyComplementsCommand {
    /**
     * First premium of the current contract, excluding tax.
     * @type {number}
     * @memberof UpdateCopropertyComplementsCommand
     */
    currentPremiumExclTax?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateCopropertyComplementsCommand
     */
    premiumYear?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateCopropertyComplementsCommand
     */
    deductibleGeneral?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateCopropertyComplementsCommand
     */
    deductibleFire?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateCopropertyComplementsCommand
     */
    deductibleTheft?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateCopropertyComplementsCommand
     */
    deductibleWaterDamage?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateCopropertyComplementsCommand
     */
    deductibleVandalism?: number | null;
    /**
     * Forecast date of the next general meeting (follow-up statistics only).
     * @type {Date}
     * @memberof UpdateCopropertyComplementsCommand
     */
    nextGeneralMeetingDate?: Date | null;
}

/**
 * Check if a given object implements the UpdateCopropertyComplementsCommand interface.
 */
export function instanceOfUpdateCopropertyComplementsCommand(value: object): value is UpdateCopropertyComplementsCommand {
    return true;
}

export function UpdateCopropertyComplementsCommandFromJSON(json: any): UpdateCopropertyComplementsCommand {
    return UpdateCopropertyComplementsCommandFromJSONTyped(json, false);
}

export function UpdateCopropertyComplementsCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCopropertyComplementsCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPremiumExclTax': json['currentPremiumExclTax'] == null ? undefined : json['currentPremiumExclTax'],
        'premiumYear': json['premiumYear'] == null ? undefined : json['premiumYear'],
        'deductibleGeneral': json['deductibleGeneral'] == null ? undefined : json['deductibleGeneral'],
        'deductibleFire': json['deductibleFire'] == null ? undefined : json['deductibleFire'],
        'deductibleTheft': json['deductibleTheft'] == null ? undefined : json['deductibleTheft'],
        'deductibleWaterDamage': json['deductibleWaterDamage'] == null ? undefined : json['deductibleWaterDamage'],
        'deductibleVandalism': json['deductibleVandalism'] == null ? undefined : json['deductibleVandalism'],
        'nextGeneralMeetingDate': json['nextGeneralMeetingDate'] == null ? undefined : (new Date(json['nextGeneralMeetingDate'])),
    };
}

export function UpdateCopropertyComplementsCommandToJSON(json: any): UpdateCopropertyComplementsCommand {
    return UpdateCopropertyComplementsCommandToJSONTyped(json, false);
}

export function UpdateCopropertyComplementsCommandToJSONTyped(value?: UpdateCopropertyComplementsCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPremiumExclTax': value['currentPremiumExclTax'],
        'premiumYear': value['premiumYear'],
        'deductibleGeneral': value['deductibleGeneral'],
        'deductibleFire': value['deductibleFire'],
        'deductibleTheft': value['deductibleTheft'],
        'deductibleWaterDamage': value['deductibleWaterDamage'],
        'deductibleVandalism': value['deductibleVandalism'],
        'nextGeneralMeetingDate': value['nextGeneralMeetingDate'] == null ? undefined : ((value['nextGeneralMeetingDate'] as any).toISOString()),
    };
}

